function Unit() {
    this.MEASURE = {
        STANDARD: { value: 0, name: "Standard" },
        METRIC: { value: 1, name: "Metric" }
    }
}
if (typeof exports !== 'undefined') {
    module.exports = Unit;
}